import React from 'react';
import { Container } from '@infoods/lifebase-ui';
import { observer } from 'mobx-react';

import { angularizeWithProviders } from '../../../shared/providers';
import { solutionsStore } from '../../../shared/stores/solutionsStore';
import { loggedInUserDataStore } from '../../../shared/stores/loggedInUserDataStore';
import {
  LbTabs,
  LbTabPanel,
  TabsConfig,
  LbToggleTabsList,
} from '../../../shared/components/tabs';
import { CoachSeatsWidget } from '../../../payment';
import { useUserRoleLabel } from '../../../shared/hooks/useUserRoleLabel';
import { NutritionRegistrationTab } from './tabs/NutritionRegistrationTab';
import { ScanIqRegistrationTab } from './tabs/ScanIqRegistrationTab';
import { SystemSettingsTab } from './tabs/SystemSettingsTab';
import classes from './NgzSettings.module.scss';

const SETTINGS_TAB = {
  NUTRITION_REGISTRATION: 'NUTRITION_REGISTRATION',
  SCAN_IQ_REGISTRATION: 'SCAN_IQ_REGISTRATION',
  COACH_STAFF_MEMBERS: 'COACH_STAFF_MEMBERS',
  SYSTEM_SETTINGS: 'SYSTEM_SETTINGS',
} as const;

const NgzEntitySettingsPage = observer(() => {
  const { solutionTypeFlags } = solutionsStore;
  const { getEntityId } = loggedInUserDataStore;
  const { getForAgent } = useUserRoleLabel();
  const entityId = getEntityId();

  const tabsConfig: TabsConfig[] = [
    {
      label: 'Nutrition Customer Registration',
      value: SETTINGS_TAB.NUTRITION_REGISTRATION,
      hide: !solutionTypeFlags.NUTRITION,
      panel: <NutritionRegistrationTab />,
    },
    {
      label: 'ScanIQ Customer Registration',
      value: SETTINGS_TAB.SCAN_IQ_REGISTRATION,
      hide: !solutionTypeFlags.SCAN_IQ,
      panel: <ScanIqRegistrationTab />,
    },
    {
      label: 'System Settings',
      value: SETTINGS_TAB.SYSTEM_SETTINGS,
      panel: <SystemSettingsTab />,
    },
    {
      label: getForAgent(),
      value: SETTINGS_TAB.COACH_STAFF_MEMBERS,
      panel: <CoachSeatsWidget entityId={entityId} mode="EDIT" />,
    },
  ];

  const defaultTab =
    tabsConfig.find((t) => !t.hide)?.value ?? SETTINGS_TAB.SYSTEM_SETTINGS;

  return (
    <Container>
      <h1 className={classes.title}>Settings</h1>
      <LbTabs defaultValue={defaultTab}>
        <LbToggleTabsList
          size="small"
          tabsConfig={tabsConfig}
          className={classes.tabsList}
        />
        <LbTabPanel tabsConfig={tabsConfig} />
      </LbTabs>
    </Container>
  );
});

angularizeWithProviders(NgzEntitySettingsPage, 'ngzEntitySettingsPage', {});

export { NgzEntitySettingsPage };
